<template>
    <div>
        <ListPage
            :query="query"
            :total="total"
            v-loading="loading"
            :data="tableData"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @search="handleSearch"
            @reset="resetQuery"
        >
            <template slot="filters">
                <el-form-item label="" prop="search_keyword">
                    <el-input v-model="query.search_keyword" placeholder="二级栏目名称" clearable @keyup.enter.native="handleSearch" />
                </el-form-item>
                <el-form-item label="所属上级栏目" prop="search_pid">
                    <el-select v-model="query.search_pid" placeholder="请选择上级栏目">
                        <el-option label="产品中心" value="1" />
                        <el-option label="解决方案" value="2" />
                        <el-option label="关于我们" value="3" />
                        <el-option label="购买渠道" value="4" />
                        <el-option label="招聘" value="5" />
                    </el-select>
                </el-form-item>
            </template>
            <template slot="btns" v-if="permission('nrgl_footer_xzlm')">
                <el-button size="mini" type="primary" @click="handleAdd"> 新增栏目 </el-button>
            </template>
            <template slot="columns">
                <el-table-column label="二级栏目名称" align="center" prop="name" />
                <el-table-column label="所属上级栏目" align="center" prop="pid_text" />
                <el-table-column label="url" align="center" prop="url" />
                <el-table-column label="创建时间" align="center" prop="create_time" />
                <el-table-column v-if="permission('nrgl_footer_bj') || permission('nrgl_footer_sc')" label="操作" align="center" width="100">
                    <template slot-scope="{ row }">
                        <el-button v-if="permission('nrgl_footer_bj')" size="mini" type="text" @click="handleEdit(row)"> 编辑 </el-button>
                        <el-button v-if="permission('nrgl_footer_sc')" size="mini" type="text" @click="handleDel(row)"> 删除 </el-button>
                    </template>
                </el-table-column>
            </template>
        </ListPage>
        <FormVue ref="form" @update="search"></FormVue>
    </div>
</template>

<script>
import { list, del } from "@/api/content/footer";
import listMixin from "@/mixins/list";
import FormVue from "./form.vue";

export default {
    components: { FormVue },
    data() {
        return {
            list,
            del,
            // 查询参数
            query: {
                search_keyword: "",
            },
            module: "栏目",
        };
    },
    mixins: [listMixin],
    mounted() {
        this.search();
    },
    methods: {
        search() {
            this._search();
        },
        handleAdd() {
            this.$refs.form.open();
        },
        handleEdit(row) {
            this.$refs.form.open(row);
        },
    },
};
</script>
